module.exports = __webpack_public_path__ + "img/item5.40a96685.png";